import FormComponent from '../FormComponent';

class SessionCheckoutSummary extends FormComponent {
	markup(value, data, titleMarkup) {
		const generateSessionMarkup = (session) => {
			const checkedPlayers = session?.players?.filter((player) => !!player.isChecked) || [];
			const playerNames = checkedPlayers?.map((player) => player.name).join(', ');

			const sessionDetails = `
				<div clsss="u-body1"><b>${session.sessionName}</b></div>
				<div clsss="u-body1">${session.sessionDateText}</div>
				<div clsss="
					${checkedPlayers?.length > 0 ? '' : 'u-mb-3'} u-body1"
				>
					${session.sesionStartTimeText} - ${session.sesionEndTimeText}
				</div>
				${checkedPlayers?.length > 0 ? `<div class="u-body1 u-mb-3">Players: ${playerNames}</div>` : ``}
			`;

			if (session.availableSeats === 0) {
				return `<div class="is-invalid-session u-my-3 u-pl-1">${sessionDetails}</div>`;
			}
			return `<div class="u-my-2">${sessionDetails}</div>`;
		};

		return `
			<div class="u-caption2">
				${data.length} ${data.length === 1 ? 'Session' : 'Sessions'}:
			</div>
			${data?.map(generateSessionMarkup).join('')}
		`;
	}

	updateSessionCheckout(sessionData) {
		this.data = [...sessionData];
	}
}

export default SessionCheckoutSummary;
